import { Checkbox, CheckboxProps } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const RememberCheckbox = withStyles({
  checked: {},
  root: {
    '&$checked': {
      color: '#2E83D9',
    },
    borderRadius: '4px',
    color: '#8083a0',
  },
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export default RememberCheckbox;
